import { render, staticRenderFns } from "./PhaseSidebar.vue?vue&type=template&id=00d6a004&"
import script from "./PhaseSidebar.vue?vue&type=script&lang=js&"
export * from "./PhaseSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports